import { withDefault } from "collection-utils";
import * as React from "react";
import { SimpleWrapper, Wrapper } from "./floating-button-style";

export interface Props {
    isEnabled?: boolean;
    yOffset?: number;
    distance?: number;
    color?: string;
    dataTest?: string;
    className?: string;
    title?: string;

    onClick: () => void;
}

export default class FloatingButton extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        const { dataTest, distance, yOffset, isEnabled, onClick, color, className, title } = this.props;

        return (
            <Wrapper
                className={className}
                color={color}
                data-test={dataTest}
                distance={withDefault(distance, 16)}
                yOffset={withDefault(yOffset, 0)}
                enabled={isEnabled !== false}
                onClick={onClick}
                title={title}>
                <div className="floating-btn-style">{this.props.children}</div>
            </Wrapper>
        );
    }
}

export interface SimpleProps {
    isEnabled?: boolean;
    color?: string;
    dataTest?: string;
    className?: string;
    title?: string;

    onClick: () => void;
}

export const FloatingButtonSimple: React.FunctionComponent<SimpleProps> = p => {
    const { dataTest, color, isEnabled, onClick, className, title } = p;

    return (
        <SimpleWrapper
            className={className}
            color={color}
            data-test={dataTest}
            enabled={isEnabled !== false}
            onClick={onClick}
            title={title}>
            <div className="floating-btn-style">{p.children}</div>
        </SimpleWrapper>
    );
};
